// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox-AXMNEZu","checked":"checked-10xDaG4","check":"check-1eGzlQl","no-check":"no-check-CQCYQNV","disabled":"disabled-lhePmry","label-text":"label-text-3mSB0Fv"};